








































import BillingProviderInvoice from '@/datatypes/billing/provider-invoice';
import BillingInvoiceService from '@/services/billing/BillingInvoiceService';
import InvoiceText from '@/components/billing/invoice-text.vue';
import CustomerText from '@/components/billing/customer-text.vue';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default Vue.extend({
  data: () => ({
    hasNext: true,
    nextPointer: undefined as string | undefined,
    billingInvoiceService: new BillingInvoiceService(),
    invoices: new Array<BillingProviderInvoice>(),
  }),

  components: {
    InvoiceText,
    CustomerText,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  methods: {
    routeChanged() {
      this.getInvoices(undefined);
    },

    getListOptions(nextPage) {
      return {
        next: nextPage,
        status: 'open',
      };
    },

    concatResponse(data: BillingProviderInvoice[]) {
      this.invoices = this.invoices.concat(data);
    },

    getInvoices(nextPage) {
      if (!nextPage) {
        this.invoices = new Array<BillingProviderInvoice>();
      }

      this.billingInvoiceService.list(this.getListOptions(nextPage)).then((response) => {
        this.concatResponse(response.data.map((data) => new BillingProviderInvoice(
          camelcaseKeysDeep(data),
        )));

        if (!nextPage && this.invoices.length === 0) {
          this.$snackbar.message('No open invoices found.');
        }

        if (response.headers.next) {
          this.nextPointer = response.headers.next;
        } else {
          this.nextPointer = undefined;
          this.hasNext = false;
        }

        if (response.data.length === 0) {
          this.hasNext = false;
        }
      });
    },

    requestNextPage() {
      this.getInvoices(this.nextPointer);
    },
  },
});
